import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { profileRequest } from '../../store/auth/authActions';

// The deposit is credited by the payment provider webhook, which can land a moment
// after the player is redirected back. Refetch the profile right away and retry a
// couple of times so the chips balance updates without a page reload.
const RETRY_DELAYS_MS = [0, 1500, 4000];

/**
 * Refetches the user profile (and therefore the chips balance) whenever a payment
 * completes successfully.
 */
export function useProfileRefreshOnPayment(
	status: 'success' | 'cancelled' | null,
	depositId?: string,
): void {
	const dispatch = useDispatch();

	useEffect(() => {
		if (status !== 'success') return;

		const timers = RETRY_DELAYS_MS.map(delay =>
			setTimeout(() => dispatch(profileRequest()), delay),
		);

		return () => timers.forEach(clearTimeout);
	}, [status, depositId, dispatch]);
}
